'use client';

import { c as _c } from "react/compiler-runtime";
import ButtonCommon from '@components/button-common/ButtonCommon';
import ButtonToTop from '@components/button-to-top/ButtonToTop';
import { showUp } from '@lib/tools/_show-up';
import { useViewport } from '@lib/tools/hooks/useViewport';
import { NewsCard } from '../NewsCard/NewsCard';
import { useNewsUI } from '../NewsUIProvider';
import style from './NewsList.module.scss';
export const NewsList = t0 => {
  const $ = _c(21);
  const {
    news
  } = t0;
  const {
    showAll,
    setShowAll
  } = useNewsUI();
  const {
    viewport,
    isMobile
  } = useViewport();
  let t1;
  if ($[0] !== isMobile || $[1] !== news || $[2] !== showAll) {
    let t2;
    if ($[4] !== isMobile || $[5] !== showAll) {
      t2 = (newsCard, i) => {
        const isHidden = isMobile && !showAll && i >= 4;
        return <div key={newsCard.id ?? i} style={{
          display: isHidden ? "none" : "block"
        }}><NewsCard item={newsCard} /></div>;
      };
      $[4] = isMobile;
      $[5] = showAll;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = news.map(t2);
    $[0] = isMobile;
    $[1] = news;
    $[2] = showAll;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== isMobile || $[8] !== news.length || $[9] !== setShowAll || $[10] !== showAll) {
    t2 = isMobile && news.length > 4 && !showAll && <ButtonCommon className={style.button} handleFuction={() => setShowAll(true)} text={"\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0441\u0451"} />;
    $[7] = isMobile;
    $[8] = news.length;
    $[9] = setShowAll;
    $[10] = showAll;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== isMobile || $[13] !== news || $[14] !== showAll || $[15] !== viewport) {
    t3 = isMobile && showAll && showUp(viewport, showAll, news) && <ButtonToTop />;
    $[12] = isMobile;
    $[13] = news;
    $[14] = showAll;
    $[15] = viewport;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== t1 || $[18] !== t2 || $[19] !== t3) {
    t4 = <div className={style.news}>{t1}{t2}{t3}</div>;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  return t4;
};